
import LeagueImg from '../atom/LeagueImg.vue';
import UILeagueTopAvatars from './UILeagueTopAvatars.vue';

export default {
  name: 'PostLeagueCard',
  components: { LeagueImg, UILeagueTopAvatars },
  props: {
    name: {
      type: String,
      required: true,
    },
    leagueId: {
      type: String,
      default: null,
    },
    leagueImageUri: {
      type: String,
      default: '',
    },
    topProfiles: {
      type: Array,
      default: () => [],
    },
    playerCount: {
      type: Number,
      default: 0,
    },
    labelKey: {
      type: String,
      default: 'you_post_in',
    },
  },
  emits: ['onLeagueClick'],
};
